import { jsx } from "panel";
import { SpinnerEl } from "common/components/spinner";
import { ToggleEl } from "common/components/toggle";
import { ToggleSize } from "common/components/toggle/types";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".cookie-center", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".header" }, " Your Privacy Rights "), /* @__PURE__ */ jsx("div", { sel: ".description" }, "California residents can request to opt-out of the sharing of their personal information for cross-contextual behavioral advertising purposes and/or from the sale of their personal information for monetary or other valuable consideration."), /* @__PURE__ */ jsx("div", { sel: ".description" }, "If you are a California resident and you would like to exercise your right to opt-out of the sharing of your personal information, you may do so by clicking on the \u201Copt-out\u201D button below. Please note that we do not sell personal information as defined by the CCPA. For a description of the information we collect, the technologies we use and the third parties with who we may share information, please refer to our", " ", /* @__PURE__ */ jsx("a", { attrs: {
    href: "/legal/privacy-policy/"
  } }, "Privacy Statement.")), /* @__PURE__ */ jsx("div", { sel: ".toggle-header" }, /* @__PURE__ */ jsx("div", { sel: ".toggle-section" }, this.state.optStatus === null ? /* @__PURE__ */ jsx(SpinnerEl, null) : /* @__PURE__ */ jsx(ToggleEl, { attrs: {
    size: ToggleSize.Large,
    selected: this.state.optStatus,
    options: [{
      label: "Opt In",
      value: "in",
      icon: "checkmark"
    }, {
      label: "Opt Out",
      value: "out",
      icon: "x"
    }]
  }, on: {
    select: this.helpers.handleSwitchChange
  } }))));
}
